import { createDraggable } from "animejs";

export default ({
    min = 0,
    max = 100,
    minValue,
    maxValue,
    formatValue = (value) => value,
    init = () => {},
    ...others
} = {}) => {
    return {
        ...others,
        min: min,
        max: max,

        minValue: minValue ?? min,
        maxValue: maxValue ?? max,

        minPosition: 0,
        maxPosition: 0,

        formatValue: formatValue,
        positionToValue(position) {
            if (this.maxPosition - this.minPosition === 0) {
                return 0;
            }

            return (
                this.min +
                ((position - this.minPosition) * (this.max - this.min)) /
                    (this.maxPosition - this.minPosition)
            );
        },
        valueToPosition(value) {
            return (
                ((value - this.min) * (this.maxPosition - this.minPosition)) /
                    (this.max - this.min) +
                this.minPosition
            );
        },
        init() {
            const min = createDraggable(this.$refs.min, {
                container: this.$el,
                y: false,
                maxVelocity: 0,
                containerFriction: 1,
                onUpdate: (draggable) => {
                    const [, maxPosition, , minPosition] = draggable.containerBounds;

                    this.maxPosition = Math.abs(maxPosition);

                    this.minValue = this.positionToValue(draggable.x);

                    if (this.minValue > this.maxValue) {
                        max.setX(draggable.x);
                    }
                },
            });

            const max = createDraggable(this.$refs.max, {
                container: this.$el,
                y: false,
                maxVelocity: 0,
                containerFriction: 1,
                onUpdate: (draggable) => {
                    const [, maxPosition, , minPosition] = draggable.containerBounds;

                    this.maxPosition = Math.abs(maxPosition);

                    this.maxValue = this.positionToValue(draggable.x);

                    if (this.maxValue < this.minValue) {
                        min.setX(draggable.x);
                    }
                },
            });

            const rect = this.$el.getBoundingClientRect();
            const maxRect = this.$refs.max.getBoundingClientRect();

            this.maxPosition = rect.width - maxRect.width;

            min.setX(this.valueToPosition(this.minValue));
            max.setX(this.valueToPosition(this.maxValue));

            init.call(this);
        },
        destroy() {},
    };
};
